// extracted by mini-css-extract-plugin
export default {"small-badge":"kxgzsm8F","selected":"D5qPhcPW"};